import React, { useCallback, useState } from 'react';

import _ from 'lodash';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { Button, IconButton } from '@material-ui/core';
import { MdHistory, MdSend } from 'react-icons/md';

import API from 'utils/api';
import { useSources, useTableStateRestore } from 'hooks';
import { ButtonContainer, Table, Tooltip } from 'components';
import { backLink } from 'utils';
import EditMessageDialog from './EditMessageDialog';

import styles from './Inbox.module.scss';

const Inbox = props => {
  const { channelId, channelName, eventId } = _.get(props, 'location.state') || {};

  const [dialog, setDialog] = useState({});
  const { tableProps, forwardLink } = useTableStateRestore(props);

  const sources = useSources();

  const fetchData = useCallback(
    ({ filter, ...rest }) =>
      API.getInboxMessages(
        channelId,
        {
          ...rest,
          query: filter
            ? JSON.stringify(
                _.mapValues(filter, value => ({ $regex: value, $options: 'i' }))
              )
            : undefined,
          select: 'user userName text createdAt',
        },
        sources
      ),
    [sources, channelId]
  );

  const sendMessage = useCallback(
    (type, body, user) =>
      API.sendMessage(
        { type, body, channel: channelId, event: eventId, inbox: user },
        sources
      ),
    [sources, channelId, eventId]
  );

  const renderActions = data => {
    const button = (Icon, onClick, title) => (
      <IconButton color="primary" onClick={onClick}>
        <Tooltip title={title} placement="top">
          <Icon />
        </Tooltip>
      </IconButton>
    );

    return (
      <div>
        {button(MdSend, () => setDialog({ send: data }), 'Send a message to this user')}

        {button(
          MdHistory,
          () => props.history.push(forwardLink('sent', data)),
          'See messages sent to this user.'
        )}
      </div>
    );
  };

  return (
    <div className={styles.inbox}>
      <ButtonContainer position="top">
        <Button variant="text" component={Link} to={backLink(props)}>
          back to channel list
        </Button>
      </ButtonContainer>

      <Table
        {...tableProps}
        data={fetchData}
        title={`Inbox - ${channelName || ''}`}
        filtering
        pageSizeOptions={[5, 10, 20, 40]}
        pageSize={10}
        search={false}
        refreshButton
        columns={[
          { title: 'User Name', field: 'userName' },
          { title: 'Message', field: 'text', weight: 4 },
          {
            title: 'Date',
            field: 'createdAt',
            align: 'center',
            initialSort: 'desc',
            defaultSort: 'desc',
            filtering: false,
            render: ({ createdAt }) => (
              <div>{moment(createdAt).format('YYYY/MM/DD hh:mm A')}</div>
            ),
          },
          {
            title: 'Actions',
            sorting: false,
            filtering: false,
            align: 'center',
            render: renderActions,
          },
        ]}
      />

      <EditMessageDialog
        open={!!dialog.send}
        to={_.get(dialog, 'send.userName')}
        onClose={() => setDialog({})}
        onMessage={(type, body) => {
          setDialog({});
          sendMessage(type, body, dialog.send.user);
        }}
      />
    </div>
  );
};

export default Inbox;
